import { skuRedirect } from '../utils/skuRedirect';

/**
 * Takes a url of type `/pages/sku/123456` and redirects the visitor to
 * the PDP for that SKU, if present. Otherwise, redirects to the homepage.
 */
document.addEventListener('DOMContentLoaded', skuRedirect);
